var map = {
	"./org-envalue.svg": 4535,
	"./org-sticky.png": 4772,
	"./org-uncapped.png": 3,
	"./org-uu.png": 9439,
	"./rabobank.png": 8074,
	"./simplemail.png": 7101,
	"./uu-mark.png": 4880,
	"./vetts.png": 2326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8745;